import axiosClient from "../common/axios_client";

class Api {
  static showCompany(name) {
    return axiosClient.get(`/api/v1/companies/${name}`).then(response => {
      return response.data;
    });
  }

  static updateCompany(data) {
    return axiosClient.patch(`/api/v1/companies/${data.name}`, JSON.stringify({
      company: data.company
    })).then(response => {
      return response.data;
    }).catch(error => {
      throw(error.response.data);
    });
  }
}

export default Api;
